import { render } from "./AppProvider.vue?vue&type=template&id=2caa7412"
import script from "./AppProvider.vue?vue&type=script&lang=js"
export * from "./AppProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__